<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="hpanel">

          <div class="panel-heading">
            Authors
          </div>
          <div class="panel-body">
            <div class="">
              <div class="table-responsive" style="border: 0">

                <table id="authorTable" class="table table-striped table-bordered table-hover " style="font-size: 10px;width: 100%">
                  <thead>
                  <tr>
                    <th>#Ref</th>
                    <th>Submit By</th>
                    <th>old / new LastName</th>
                    <th>old / new FirstName</th>
                    <th>old / new Email</th>
                    <th>old / new Phone</th>
                    <th>old / new Orga. name</th>
                    <th>old / new Orga. country</th>
                    <th>old / new Orga. city</th>
                    <th>Status</th>
                    <th>Treated By</th>
                    <th>Action</th>

                  </tr>
                  </thead>
                </table>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  name: 'AuthorsData',
  props: [],
  mounted () {
    var dataTable = $('#authorTable').DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      bPaginate: true,
      ajax: {
        url: this.$apiUrl + '/editData/authors',
        dataSrc: 'data',
        // beforeSend: config
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', 'Bearer ' + localStorage.default_auth_token
          )
        }
      },
      columns: [
        {data: 'id'},
        {data: 'user_id'},
        {data: 'lastname', searchable: false, orderable: false},
        {data: 'firstname', searchable: false, orderable: false},
        {data: 'email', searchable: false, orderable: false},
        {data: 'phone', searchable: false, orderable: false},
        {data: 'orga. name', searchable: false, orderable: false},
        {data: 'orga. country', searchable: false, orderable: false},
        {data: 'orga. city', searchable: false, orderable: false},
        {data: 'status'},
        {data: 'treated_by'},
        {data: null, searchable: false, orderable: false}
      ],
      columnDefs: [
        {
          'targets': 2,
          'data': 'lastname',
          'render': function (data, type, row) {
            return row.lastName_old + ' / ' + row.lastName_new
          }
        }, {
          'targets': 3,
          'data': 'firstname',
          'render': function (data, type, row) {
            return row.firstName_old + ' / ' + row.firstName_new
          }
        }, {
          'targets': 4,
          'data': 'email',
          'render': function (data, type, row) {
            return row.email_old + ' / ' + row.email_new
          }
        }, {
          'targets': 5,
          'data': 'phone',
          'render': function (data, type, row) {
            return row.phone_old + ' / ' + row.phone_new
          }
        }, {
          'targets': 6,
          'data': 'orga. name',
          'render': function (data, type, row) {
            return row.organisationName_old + ' / ' + row.organisationName_new
          }
        }, {
          'targets': 7,
          'data': 'orga. country',
          'render': function (data, type, row) {
            return row.organisationCountry_old + ' / ' + row.organisationCountry_new
          }
        }, {
          'targets': 8,
          'data': 'orga. city',
          'render': function (data, type, row) {
            return row.organisationCity_old + ' / ' + row.organisationCity_new
          }
        }, {
          'targets': 11,
          'data': null
        }
      ],
      createdRow: function (row, data, index) {
        let tds = $('td', row)
        tds.each((index, td) => {
          $(td).css('vertical-align', 'middle')

          if (index === 2 && data.lastName_old !== data.lastName_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 3 && data.firstName_old !== data.firstName_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 4 && data.email_old !== data.email_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 5 && data.phone_old !== data.phone_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 6 && data.organisationName_old !== data.organisationName_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 7 && data.organisationCountry_old !== data.organisationCountry_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 8 && data.organisationCity_old !== data.organisationCity_new) {
            $(td).css('border', '1px solid red')
          } else if (index === 9) {
            switch (data.status) {
              case 'WAITING_VALIDATION':
                $(td).css('color', 'orange')
                break
              case 'VALIDATED':
                $(td).css('color', 'green')
                break
              case 'REJECTED':
                $(td).css('color', 'red')
                break
            }
          } else if (index === 11 && data.organisationCity_old !== data.organisationCity_new) {
            switch (data.status) {
              case 'WAITING_VALIDATION':
                $(td).html('<button type="button" class="btn btn-xs btn-outline btn-success validateData" >Validate</button>')
                break
              case 'VALIDATED':
                $(td).html('')
                break
              case 'REJECTED':
                $(td).html('')
                break
            }
          }
        })
      }
    })

    $('#authorTable tbody').on('click', '.validateData', (e) => {
      let data = dataTable.row($(this).parents('tr')).data()
      this.validateData(data)
    })
  },
  methods: {
    validateData: function (data) {
      this.axios.patch('editData/' + data.id + '/validate')
        .then((response) => {
          this.$notify({
            type: 'success',
            title: 'Author information\'s validated',
            placement: 'bottom-right'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/validateData/AuthorsData.vue